import { useState, useEffect, useCallback } from "react";
import useHttp from "./useHttp";

export default function useRcsMessagingServices(savedNumbersList, integId, appProperties, phoneNumber) {
  const { fetchData } = useHttp();
  const [rcsSids, setRcsSids] = useState(new Set());
  const [rcsLoading, setRcsLoading] = useState(false);

  useEffect(() => {
    if (!phoneNumber || !integId || !appProperties?.osyncId || !Array.isArray(savedNumbersList)) {
      setRcsSids(new Set());
      return;
    }

    const rightServiceName = appProperties?.installedApps?.find((app) => app?.integProps?.integId === integId)?.right
      ?.service_name;

    if (rightServiceName !== "twilio") {
      setRcsSids(new Set());
      return;
    }

    const selected = savedNumbersList.find((num) => num?.phoneNumber === phoneNumber);
    if (selected?.isMessagingService !== "true") {
      setRcsSids(new Set());
      return;
    }

    const fetchRcs = async () => {
      setRcsLoading(true);
      try {
        const body = [{ messageServiceId: selected.phoneNumber }];
        const response = await fetchData(`omessage/${integId}/rcsServices`, "POST", body, appProperties);
        const parsed = JSON.parse(response);
        const rcsData = parsed?.data?.data ?? [];
        setRcsSids(new Set(rcsData.map((item) => item.messageServiceId)));
      } catch (error) {
        console.error("Error fetching RCS services:", error);
        setRcsSids(new Set());
      } finally {
        setRcsLoading(false);
      }
    };
    fetchRcs();
  }, [phoneNumber, savedNumbersList, integId, appProperties?.osyncId, fetchData]);

  const isRcsNumber = useCallback((phoneNumber) => rcsSids.has(phoneNumber), [rcsSids]);

  return { rcsSids, rcsLoading, isRcsNumber };
}
